import React from "react"
import { TabsContext } from './Tabs'

const TabContent = ({ index, children }) => {
    const data = React.useContext(TabsContext)
    return (
        data.activeTab === index ? children : null
    )
}

export default TabContent
